import { api } from "@/api/axios.ts";
import { ApiEmploymentType, ApiEmploymentTypeSavePayload } from "@/types/employment-types.types.ts";

export const apiEmploymentTypes = {
  getAll: () => {
    return api.get<ApiEmploymentType[]>(`/api/v1/employment-types`);
  },
  create: (payload: ApiEmploymentTypeSavePayload) => {
    return api.post<ApiEmploymentType>(`/api/v1/employment-types`, payload);
  },
  update: (id: number, payload: ApiEmploymentTypeSavePayload) => {
    return api.put<ApiEmploymentType>(`/api/v1/employment-types/${id}`, payload);
  },
  delete: (id: number) => {
    return api.delete(`/api/v1/employment-types/${id}`);
  },
};
